import Footer from "@/Components/User/Common/Footer";
import Header from "@/Components/User/Common/Header";
import CreateUserModal from "@/Components/User/Modal/CreateUserModal";
import OTPModal from "@/Components/User/Modal/OTPModal";
import { useBuy } from "@/context/buy";
import { useRouter } from "next/router";
import { AnimatePresence } from "framer-motion";
import CustomTicketLinkModal from "@/Components/User/Modal/CustomTicketLinkModal";

export default function User({ children, ref = null }) {

    const { openModal } = useBuy();
    const router = useRouter();

    return (
        <div ref={ref} className={` ${ref ? 'max-h-screen overflow-auto' : ''} `}>
            <AnimatePresence>
                {openModal.create && <CreateUserModal />}
                {openModal.otp && <OTPModal />}
                {openModal.custom && <CustomTicketLinkModal />}
            </AnimatePresence>

            <Header />
            <main>{children}</main>
            <div className={`${router.pathname.includes("tickets") || router.pathname.includes("artist-ticket") || router.pathname.includes("tickets") ? "hidden" : ""}`}>
                <Footer />
            </div>
        </div>
    )
}